import React from 'react';
import {map} from 'lodash';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell} from 'recharts';
import {FILTER_TYPES, COLORS} from '../../../common/dictionaries/iccChart';
import {
  transformDataChart,
  tranformCurrency,
  sumQuantites,
  numberWithCommas,
} from '../../util';
import {
  MONEY,
  AVERAGE,
  TOTAL_COLUMN,
  COLORS_CHART_TYPE,
} from '../../constants';


function filterColorByEntry(letter) {
  if (letter.includes(FILTER_TYPES.accesories)) {
    return '#E68765';
  } else if (letter.includes(FILTER_TYPES.spareparts)) {
    return '#70A3E6';
  } else if (letter.includes(FILTER_TYPES.other)) {
    return '#466AB3';
  }
  return null;
}

const CustomTooltip = ({payload, active, type}) => {
  if (active) {
    const row = payload[0];
    const value = type ? row.payload.label : row.payload.quantity;
    const letter = row.payload.letter;
    return (
      <div className='custon-tooltip-icc'>
        <p className='custon-tooltip-icc-title'>{letter}</p>
        <p className='custon-tooltip-icc-value'>{value}</p>
      </div>
    );
  }
  return null;
};

const CustomTooltipLetter = ({payload, active, type}) => {
  if (active) {
    const row = payload[0];
    const data = row.payload;
    return (
      <div className='custon-tooltip-icc'>
        {map(data, (element, index) => {
          const formatElement = type ?
            tranformCurrency(element) :
            numberWithCommas(element);
          const value = `${index} : ${formatElement}`;
          if (element === 0) {
            return;
          }
          return (
            <div className='letter-container-tip' key={index}>
              <p
                style={{'color': COLORS[index]}}
                key={index}
                className='custon-tooltip-icc-value'
              >
                {index === 'letter' ? element : value}
              </p>
              <p className='pigment' style={{'backgroundColor': COLORS[index]}}>
                {' '}
              </p>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

const ChartType = ({data, type, totalSale, selectBtn, height}) => {
  const total =
    selectBtn !== AVERAGE ? sumQuantites(data, TOTAL_COLUMN) : totalSale;
  return (
    <div>
      <div className='icc-chart-total ml-3'>
        <h4>TOTAL</h4>
        <h3> {type ? tranformCurrency(total) : numberWithCommas(total)} </h3>
      </div>
      {data.length > 0 ? (
        <BarChart width={900} height={height} data={data}>
          <CartesianGrid strokeDasharray='3 4' />
          <YAxis />
          <Tooltip content={<CustomTooltip type={type} />} />

          <XAxis dataKey='letter' />
          <Bar dataKey={TOTAL_COLUMN}>
            {data.map((entry, index) => {
              const filterColor = filterColorByEntry(entry.letter);
              const color = filterColor ?
                filterColor :
                COLORS_CHART_TYPE[index];
              return <Cell key={index} fill={color} />;
            })}
          </Bar>
        </BarChart>
      ) : (
        <h1 className='mt-3'>No hay datos</h1>
      )}
    </div>
  );
};

const ChartLetter = ({data, type, height}) => {
  return (
    <div>
      {data.length > 0 ? (
        <BarChart width={1000} height={height} data={data}>
          <CartesianGrid strokeDasharray='3 4' />
          <YAxis />
          <Tooltip content={<CustomTooltipLetter type={type} />} />
          <XAxis dataKey='letter' />
          {map(
            COLORS,
            (color, index) =>
              index !== 'letter' && (
                <Bar key={index} dataKey={index} fill={color} stackId='st' />
              )
          )}
        </BarChart>
      ) : (
        <h1 className='mt-3'>No hay datos</h1>
      )}
    </div>
  );
};

const ChartIcc = ({data, type, selectBtn, totalSale}) => {
  const dataChart = type ? transformDataChart(data) : data;
  const hWindows = window.innerHeight;
  const height = hWindows >= 1000 ? 550 : 370;
  return (
    <div>
      {type ? (
        <ChartType
          data={dataChart}
          selectBtn={selectBtn}
          type={selectBtn === MONEY}
          totalSale={totalSale}
          height={height}
        />
      ) : (
        <ChartLetter
          data={dataChart}
          type={selectBtn === MONEY}
          height={height}
        />
      )}
    </div>
  );
};

export default ChartIcc;
